<template>
  
  <div class="layout-box" >
    <div class="banner-box"></div>
    <div class="form-box">
      <div class="form-title">参会人信息</div>
      <el-form
          ref="form"
          class="form"
          :model="form"
          :rules="rules"
          label-width="280px"
          size="large"
          @submit.prevent
      >
        <el-form-item prop="userName" label="姓名">
          <el-input
              v-model="form.userName"
              :maxlength="100"
              placeholder="请填写参会人的姓名"
          />
        </el-form-item>
        <el-form-item prop="userPosition" label="职位">
          <el-input
              v-model="form.userPosition"
              :maxlength="100"
              placeholder="请填写参会人的职位"
          />
        </el-form-item>
        <el-form-item prop="phone" label="联系电话">
          <el-input
              v-model="form.phone"
              :maxlength="11"
              placeholder="请填写参会人的电话"
          />
        </el-form-item>
        <el-form-item prop="imgCaptcha" label="图形验证码">
          <el-row class="w-p-100 h-40" justify="space-between">
            <el-col :span="18">
              <el-input v-model="form.imgCaptcha" placeholder="请填写图形验证码"/>
            </el-col>
            <el-col :span="6" class="imgCode">
              <el-image class="cursor" :src="imgKeyData.img" @click="getImgCaptcha">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline icon"></i>
                </div>
              </el-image>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item prop="wechat" label="微信号">
          <el-input
              v-model="form.wechat"
              :maxlength="100"
              placeholder="请填写参会人的微信"
          />
        </el-form-item>
        <el-form-item prop="email" label=" 电子邮箱">
          <el-input
              v-model="form.email"
              :maxlength="50"
              placeholder="请填写参会人的电子邮箱"
          />
        </el-form-item>
        <el-form-item prop="companyName" label="公司名称">
          <el-input
              v-model="form.companyName"
              :maxlength="100"
              placeholder="请填写参会人的公司名称"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button
              class="submit-btn"
              type="primary"
              size="large"
              :disabled="loading"
              @click="submitForm()"
          >
            提交报名
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rule-box">
      <div class="rule-title">报名须知</div>
      <div class="rule-content" >
        1. 报名时间：2025年7月25日 - 2025年8月14日
        <br>
        2. 活动时间：2025年8月15日下午14:00-17:30
        <br>
        3. 活动地点：上海世博洲际酒店-二层-大宴会厅
        <br>
        4. 详细地址：上海浦东新区雪野路1188号
        <br>
        5. 请使用真实、准确、完整的个人信息进行报名；
        <br>
        6. 报名成功后，金标联盟客服将会添加您的微信发送邀请函，请留意添加好友信息;
        <br>
        7. 报名审核通过即确认席位，参会资格不可转让，如无法参加，无需取消；
        <br>
        8. 如有疑问请咨询官方客服微信：itgsakf
      </div>
    </div>
  </div>
</template>
<script>
import { singleActivitySever } from "@/common/api-config";
export default {
  data() {
    //验证码检验
    var checkImgCaptcha = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入图形中的验证码"));
      } else if (value.length == 4) {
        singleActivitySever
          .checkImgCaptcha({
            imgCaptcha: value,
            ckey: this.form.ckey,
          })
          .then((res) => {
            if (res.code == 0) {
              callback();
            } else if (res.code == 1019) {
              // 图片验证码过期，需要重新获取图片验证码
              this.getImgCaptcha();
              callback(new Error("图形验证码已失效"));
            } else {
              callback(new Error("图形验证码输入错误"));
            }
          });
      } else {
        callback(new Error("图形验证码输入错误"));
      }
    };
    return {
      loading:false,
      form: {
        organizerActivityId: "1",
        userName: "",
        userPosition: "",
        phone: "",
        email: "",
        imgCaptcha: "",
        companyName: "",
        wechat: "",
      },
      formValid: {},
      imgKeyData: {},
      rules: {
        userName: [{required: true, message: "不可为空", trigger: "blur"}],
        userPosition: [{required: true, message: "不可为空", trigger: "blur"}],
        phone: [
          {required: true, message: "不可为空", trigger: "blur"},
          {
            pattern: /^1[0-9]{10}$/,
            message: '请输入合法的手机号码',
            trigger: 'blur'
          },
        ],
        imgCaptcha: [
          {required: true, message: "不可为空", trigger: "blur"},
          {validator: checkImgCaptcha, trigger: "blur"}
        ],
        wechat: [{required: true, message: "不可为空", trigger: "blur"}],
        email: [
          {required: true, message: "不可为空", trigger: "blur"},
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: '请输入正确的邮箱格式',
            trigger: 'blur'
          },
        ],
        companyName: [{required: true, message: "不可为空", trigger: "blur"}],
      },
    };
  },
  created() {
    if(this.$route.query.id){
      this.form.organizerActivityId=this.$route.query.id;
    }
    this.getEnvironment();
  },
  mounted() {
    this.getImgCaptcha();
  },
  methods: {
    getEnvironment(){
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        // 如果屏幕宽度小于等于768px，则认为是移动端
        const deviceType = screenWidth <= 768 ? 'mobile' : 'pc';
        // 如果是PC端但访问的是移动端URL，则跳转到PC端URL
        if (deviceType === 'mobile') {
          const currentUrl = window.location.pathname;
          this.$router.replace({path: '/activity/mobile', query: {'id': this.$route.query.id}});
        }
    },
    //提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          singleActivitySever.registrations(this.form).then((result) => {
            this.loading = false;
            if (result.code == 0) {
              this.$alert('请耐心等待官方的审核', '报名成功', {
                confirmButtonText: '确定',
                callback: action => {
                  location.reload();
                }
              });
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    //拿图片验证码数据
    getImgCaptcha() {
      singleActivitySever.getImgCaptcha().then((result) => {
        if (result.code == 0) {
          this.imgKeyData = result.data[0].captcha;
          this.form.ckey = this.imgKeyData.key;
        }else{
          this.$message.error(result.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">

.layout-box {
  background-color: #000;
  .banner-box {
    width: 100%;
    height: 800px;
    background-image: url(~@/assets/img/activity/web/banner.jpg);
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .rule-box {
    margin: 0 auto;
    width: 1200px;
    padding-bottom: 80px;

    .rule-title {
      position: relative;
      margin-bottom: 68px;
      font-weight: bold;
      font-size: 40px;
      color: #E9C799;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -32px;
        width: 100px;
        height: 8px;
        background: linear-gradient( 90deg, #FAE7BD 0%, #C7A276 100%);
        border-radius: 8px;
      }
    }

    .rule-content {
      font-size: 18px;
      color: #DDDDDD;
      line-height: 35px;
      white-space: pre-line; /* 合并空格但保留换行 */
    }
  }

  .form-box {
    margin: 0 auto;
    width: 1200px;
    padding-top: 60px;
    padding-bottom: 60px;
    .form-title {
      position: relative;
      margin-bottom: 68px;
      font-weight: bold;
      font-size: 40px;
      color: #E9C799;

      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -32px;
        width: 100px;
        height: 8px;
        background: linear-gradient( 90deg, #FAE7BD 0%, #C7A276 100%);
        border-radius: 8px;
      }
    }

    .form {
      padding-top: 60px;
      padding-right: 256px;
      padding-bottom: 50px;
      border-radius: 20px;
      background-color: #19191B;
      /deep/ .el-form-item__label {
        color: #ccc;
      }

      /deep/ .el-input__inner {
        border: 1px solid rgba(255,255,255,0.1);
        color: #ccc;
        background-color: #19191B;
        box-shadow: 0 0 0 1px #666666;
      }

      /deep/ .el-input__inner::placeholder {
        color: #666666 !important;
        -webkit-text-fill-color: #666666 !important;
      }
      .imgCode{
        padding-left: 20px;
        height:40px;
        overflow: hidden;
        .cursor{
          width:100%;
          height:40px;
          border-radius:4px; 
          .image-slot{
            background-color:#ccc;
            text-align:center;
          }
        }
      }

      .code-box {
        display: flex;
        width: 100%;

        .code-input {
          flex: 1;
        }

        .code-btn {
          margin-left: 10px;
          width: 138px;
          background: linear-gradient(359deg, #0A40DD 0%, #0C43DC 100%);
          border-radius: 4px;
          border-color: #0A40DD;
        }
      }
    }

    .submit-btn {
      width: 200px;
      background: linear-gradient( 90deg, #FAE7BD 0%, #C7A276 100%);
      border-radius: 4px;
      border-color: #FAE7BD;
      font-size: 14px;
      color: #212121;
      font-weight: 800;
    }
  }
}

</style>

